import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-woundphraseboth',
  templateUrl: './woundphraseboth.component.html',
  styleUrls: ['./woundphraseboth.component.css']
})
export class WoundphrasebothComponent implements OnInit {
  @Input() note: any;

  constructor() { }

  ngOnInit(): void {
  }

}
